import ComingSoon from '@/components/ComingSoon'

function Capacitaciones() {
  return (
    <ComingSoon
      title="Módulo de Capacitaciones"
      description="Cursos, talleres, seminarios y certificaciones que se integrarán automáticamente a tu perfil profesional. Disponible muy pronto."
    />
  )
}

export default Capacitaciones
